import React from "react";
import ImageGallery from "react-image-gallery";

interface Props {
  images: string[];
}

function PhotoGallery({ images }: Props) {
  return (
    <ImageGallery
      stopPropagation={true}
      showNav={false}
      showPlayButton={false}
      showFullscreenButton={false}
      items={images.map((url) => ({
        original: url,
        thumbnail: url,
      }))}
    />
  );
}

export default PhotoGallery;
